import Evented from "@ember/object/evented"
import Service from "@ember/service"
import $ from "jquery"
import _ from "lodash"

export default class Windowscroll extends Service.extend(Evented) {
  init() {
    super.init(...arguments)
    this.scrollTop = null
    this.isScrollingUp = false
    if (typeof $ !== "undefined") {
      let debounedScroll = _.debounce((e) => {
        this._onScroll(e, $(window).scrollTop())
      }, 30)
      $(window).on("wheel", debounedScroll)
      this.set("scrollTop", $(window).scrollTop())
    }
  }

  destroy() {
    super.destroy(...arguments)
    if (typeof $ !== "undefined") {
      $(window).off("scroll")
    }
  }

  _onScroll(e, top) {
    if (this.isDestroyed || this.isDestroying) return
    this.set("isScrollingUp", this.scrollTop > top)
    this.set("scrollTop", top)
    this.trigger("scroll", e, top)
  }
}
